/* Saint Texas site helpers.
   Theme preview: Shopify identifies an unpublished-theme preview with a
   `preview_theme_id` query param that does not follow ordinary links, so
   clicking from the preview homepage into a builder page would land on the
   LIVE theme's version. When that param is present, carry it onto every
   same-site link on the page. Does nothing on the published storefront. */
(function () {
  "use strict";
  var current = new URLSearchParams(window.location.search);
  var keys = ["preview_theme_id", "_fd", "_ab", "_sc"].filter(function (k) { return current.has(k); });
  if (keys.indexOf("preview_theme_id") === -1) return;

  function patch(a) {
    var href = a.getAttribute("href");
    if (!href || href.charAt(0) === "#" || /^(mailto|tel|javascript):/i.test(href)) return;
    var url;
    try { url = new URL(href, window.location.origin); } catch (e) { return; }
    if (url.origin !== window.location.origin) return;
    var changed = false;
    keys.forEach(function (k) {
      if (!url.searchParams.has(k)) { url.searchParams.set(k, current.get(k)); changed = true; }
    });
    if (changed) a.setAttribute("href", url.pathname + url.search + url.hash);
  }

  function patchAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll("a[href]"), patch);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { patchAll(); });
  else patchAll();

  // Menus, drawers and cart fragments are injected after load.
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      Array.prototype.forEach.call(r.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches("a[href]")) patch(n);
        patchAll(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 27 Sep: on collection pages the "Start your project" heading lines up with the first product
   (the grid sits to the right of the filter sidebar, so the heading is shifted by the same amount). */
(function () {
  function align() {
    return;   /* 27 Sep (Steve): heading sits at the far left of the page now — alignment turned off */
    var grid = document.querySelector(".product-grid"), wrap = document.querySelector(".collection-wrapper");
    if (!grid || !wrap) return;
    var sec = wrap.closest(".shopify-section"), prev = sec && sec.previousElementSibling;
    while (prev && !prev.querySelector("h1")) prev = prev.previousElementSibling;
    var h = prev && prev.querySelector("h1"); if (!h) return;
    var box = h.closest(".text-block") || h;
    box.style.marginLeft = "0px";
    var d = Math.round(grid.getBoundingClientRect().left - box.getBoundingClientRect().left);
    box.style.marginLeft = d > 0 ? d + "px" : "0px";
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", align); else align();
  window.addEventListener("resize", align);
  window.addEventListener("load", align);
})();

/* 27 Sep: chip filter bar on collection pages (sticky under the header), Customink-style.
   Built from the sidebar filters: one chip per filter group; a chip opens a small dropdown whose ticks click
   the matching sidebar checkbox, so Horizon still does the filtering. Groups without checkboxes (price range)
   scroll to that group in the sidebar. "Filter" opens the sidebar / the phone filter drawer. Rebuilt whenever
   Horizon re-renders the filters. */
(function () {
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var openKey = null, busy = false;
  function sidebar() { return document.querySelector(".facets--vertical") || document.querySelector(".facets"); }
  function groups() {
    var f = sidebar(); if (!f) return [];
    return Array.prototype.map.call(f.querySelectorAll("details.facets__panel"), function (d, i) {
      var s = d.querySelector("summary"), title = s ? (s.querySelector(".facets__label, span") || s).textContent.trim().replace(/\s*\(\d+\)\s*$/, "") : "Filter " + (i + 1);
      var boxes = Array.prototype.filter.call(d.querySelectorAll("input"), function (x) { return x.type === "checkbox" || x.type === "radio"; });
      return { key: title, el: d, boxes: boxes };
    }).filter(function (g) { return g.key; });
  }
  function labelOf(inp) {
    var l = inp.closest("label") || (inp.id && document.querySelector('label[for="' + inp.id + '"]')) || inp.parentElement;
    return (l ? l.textContent : inp.value).replace(/\s+/g, " ").trim();
  }
  function build() {
    var wrap = document.querySelector(".collection-wrapper"); if (!wrap || busy) return;
    var gs = groups(); if (!gs.length) return;
    busy = true;
    var bar = document.getElementById("st-chipbar");
    if (!bar) { bar = document.createElement("div"); bar.id = "st-chipbar"; bar.className = "st-chipbar"; wrap.parentNode.insertBefore(bar, wrap); }
    var html = '<div class="st-chipbar__row"><button type="button" class="st-chip st-chip--filter" data-chip="__all"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M2 4h12M4 8h8M6 12h4" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>Filter</button>';
    gs.forEach(function (g) {
      var n = g.boxes.filter(function (b) { return b.checked; }).length;
      html += '<div class="st-chipwrap"><button type="button" class="st-chip' + (n ? " st-chip--on" : "") + '" data-chip="' + esc(g.key) + '" aria-expanded="' + (openKey === g.key) + '">' + esc(g.key) + (n ? " (" + n + ")" : "") + (g.boxes.length ? ' <span class="st-chip__caret">▾</span>' : "") + "</button>";
      if (g.boxes.length && openKey === g.key) {
        html += '<div class="st-chipdrop" role="menu">' + g.boxes.map(function (b, i) {
          return '<label class="st-chipopt' + (b.disabled ? " is-off" : "") + '"><input type="checkbox" data-g="' + esc(g.key) + '" data-i="' + i + '"' + (b.checked ? " checked" : "") + (b.disabled ? " disabled" : "") + "> " + esc(labelOf(b)) + "</label>";
        }).join("") + "</div>";
      }
      html += "</div>";
    });
    html += "</div>";
    bar.innerHTML = html;
    setTop();
    busy = false;
  }
  function setTop() {
    var bar = document.getElementById("st-chipbar"), h = document.getElementById("header-component");
    if (bar) bar.style.top = (h ? Math.round(h.getBoundingClientRect().height) : 0) + "px";
  }
  document.addEventListener("click", function (e) {
    var chip = e.target.closest && e.target.closest("#st-chipbar [data-chip]");
    if (chip) {
      var k = chip.getAttribute("data-chip");
      if (k === "__all") {
        var t = document.querySelector(".facets-toggle__button");
        if (t && t.offsetParent) t.click(); else { var f = sidebar(); if (f) f.scrollIntoView({ behavior: "smooth", block: "start" }); }
        openKey = null; build(); return;
      }
      var g = groups().find(function (x) { return x.key === k; });
      if (g && !g.boxes.length) { g.el.open = true; g.el.scrollIntoView({ behavior: "smooth", block: "center" }); openKey = null; build(); return; }
      openKey = openKey === k ? null : k; build(); return;
    }
    var opt = e.target.closest && e.target.closest("#st-chipbar .st-chipopt input");
    if (opt) {
      var gg = groups().find(function (x) { return x.key === opt.getAttribute("data-g"); });
      var b = gg && gg.boxes[+opt.getAttribute("data-i")];
      if (b) b.click();
      return;
    }
    if (openKey && !(e.target.closest && e.target.closest("#st-chipbar"))) { openKey = null; build(); }
  });
  var t;
  function soon() { clearTimeout(t); t = setTimeout(build, 60); }
  function start() {
    build();
    new MutationObserver(function (m) {
      if (m.every(function (r) { return r.target.closest && r.target.closest("#st-chipbar"); })) return;
      if (document.querySelector(".collection-wrapper")) soon();
    }).observe(document.querySelector("main") || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["checked"] });
    document.addEventListener("change", function (e) { if (e.target.closest && e.target.closest(".facets")) soon(); });
    window.addEventListener("resize", setTop);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
